import { getProposalContent } from 'common/api/v1/core';

import * as companySelectors from '../../companyGeneral/selectors';
import {
    FETCH_PROPOSAL_CONTENT,
    FETCH_PROPOSAL_CONTENT_SUCCESS,
    FETCH_PROPOSAL_CONTENT_FAILURE,
} from '../actionTypes';
import { templateRenderActions } from '../reducer';

export default (contentId, initTemplate) => (dispatch, getState) => {
    const companyId = companySelectors.getCompanyId(getState());
    dispatch(templateRenderActions[FETCH_PROPOSAL_CONTENT]());
    getProposalContent(contentId)
        .then((response) => {
            dispatch(
                templateRenderActions[FETCH_PROPOSAL_CONTENT_SUCCESS](
                    response.data.data,
                ),
            );
            initTemplate(response.data.data, companyId);
        })
        .catch((error) =>
            dispatch(
                templateRenderActions[FETCH_PROPOSAL_CONTENT_FAILURE](error),
            ),
        );
};
